<template>
  <div class="grid" style="flex-wrap: wrap;">
    <div class="grid__item grid__item--double skeleton"></div>
    <div class="grid__item grid__item--single skeleton"></div>
    <div class="grid__item grid__item--single skeleton"></div>
    <div class="grid__item grid__item--double skeleton"></div>
    <div class="grid__item grid__item--double skeleton"></div>
    <div class="grid__item grid__item--single skeleton"></div>
  </div>
</template>

<style>
  .skeleton {
    background: #ECEEEF;
    animation: pulse 2s linear infinite;
  }

  @keyframes pulse {
    0% {
      background: #ECEEEF;
    }

    50% {
      background: #B5B8BC;
    }
  }
</style>
